import React from 'react';
import { getBarColor } from '../utils/analysisUtils';

const AchievementBar = ({ actual, target }) => {
  const percentage = target > 0 ? Math.min((actual / target) * 100, 100) : 0;
  const displayPercentage = target > 0 ? ((actual / target) * 100).toFixed(1) : '0.0';

  return (
    <div className="w-full min-w-[120px]">
      <div className="flex justify-between items-center mb-1">
        <span className="text-[10px] font-bold text-gray-500 uppercase">Achievement</span>
        <span className="text-xs font-extrabold text-slate-700">{displayPercentage}%</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden shadow-inner">
        <div 
          className={`h-full transition-all duration-700 ease-in-out ${getBarColor(percentage)}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default AchievementBar;